<template>
    <div id="wap" class="wrapper" :style="{position:'fixed',top:position.y +'px',left:position.x+'px'}">
        <div v-if="!showList.length" class="empty">无搜索结果</div>
        <div id="atlist">
            <div v-for="(item,i) in showList" :id="'id' + i" :key="item.f_UserId" class="item" :class="{'active': i === index}" ref="usersRef"
            @click.prevent="clickAt($event,item)" @mouseenter="hoverAt(i)">
                <div class="name">{{item[userNameKey]}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'editorAtDg',
    props: {
        atKeyword: {
            default: ''
        },
        users: {
            default: () => {
                return []
            }
        },
        userNameKey: {
            default: 'userName'
        },
        userValueKey: {
            default: 'f_UserId'
        },
        position: {
            type: Object,
            default: () => {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    },
    data() {
        return {
            index: 0
        };
    },
    computed: {
        showList() {
            let keyWord = this.atKeyword.toLocaleLowerCase(),
                arr = this.users,
                result = arr.filter(t => t[this.userNameKey].indexOf(keyWord) != -1 || window.Mtils.utils.makePy(t
                    [this.userNameKey], true).toLocaleLowerCase().indexOf(keyWord) != -1 || window.Mtils.utils
                .makePy(t[this.userNameKey]).toLocaleLowerCase().indexOf(keyWord) != -1)
            return result
        }
    },
    // mounted() {
    //     document.addEventListener('keyup', this.keyDownHandler)
    // },
    // beforeDestroy() {
    //     document.removeEventListener('keyup', this.keyDownHandler)
    // },
    methods: {
        keyDownHandler(e) {
            if (e.code === 'Escape') {
                this.$emit('onHide')
                return
            }
            // 键盘按下 => ↓
            if (e.code === 'ArrowDown') {
                if (this.index >= this.showList.length - 1) {
                    this.index = 0
                } else {
                    this.index = this.index + 1
                }
                let t = document.getElementById("id" + this.index).getBoundingClientRect()
                let div = document.getElementById("wap")
                let w = document.getElementById("wap").getBoundingClientRect()
                if(t.top - w.top + t.height > w.height){
                    div.scrollTop = div.scrollTop + t.height
                } else {
                    div.scrollTop = 0
                }
            }
            // 键盘按下 => ↑
            if (e.code === 'ArrowUp') {
                if (this.index <= 0) {
                    this.index = this.showList.length - 1
                } else {
                    this.index = this.index - 1
                }
                let t = document.getElementById("id" + this.index).getBoundingClientRect()
                let div = document.getElementById("wap")
                let w = document.getElementById("wap").getBoundingClientRect()
                if(t.top < w.top){
                    div.scrollTop = div.scrollTop - t.height
                } else if (t.top - w.top > w.height - t.height) {
                    div.scrollTop = document.getElementById("atlist").getBoundingClientRect().height
                }
            }
            if (e.code === 'Enter') {
                if (this.showList.length) {
                    const user = this.showList[this.index]
                    this.$emit('onPickUser', {type: 'enter', user})
                    this.index = -1
                }
            }
        },
        hoverAt(idx) {
            this.index = idx
        },
        clickAt(e, item) {
            this.$emit('onPickUser', {type: 'click', user: item})
            this.index = -1
        },
    }
}
</script>
<style lang="less">
    .wrapper {
        width: 140px;
        max-height: 300px;
        overflow-y: auto;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        box-sizing: border-box;
        padding: 6px 0;
        transform: translateY(-100%);
        .empty {
            font-size: 14px;
            padding: 0 20px;
            color: #999;
        }

        .item {
            font-size: 14px;
            padding: 0 20px;
            line-height: 34px;
            cursor: pointer;
            color: #606266;

            &.active {
                background: #f5f7fa;
                color: blue;

                .id {
                    color: blue;
                }
            }

            &:first-child {
                border-radius: 5px 5px 0 0;
            }

            &:last-child {
                border-radius: 0 0 5px 5px;
            }

            .id {
                font-size: 12px;
                color: rgb(83, 81, 81);
            }
        }
    }

</style>